import { Box } from '@mui/material';
import { Outlet } from 'react-router';

import { BackendReachable } from './BackendReachable';
import { Footer } from './Footer';
import { Header } from './Header';
import { WithAuth } from './WithAuth';

export const LayoutWithAuth = () => (
  <WithAuth>
    <BackendReachable>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <Header />
        <Box sx={{ display: 'flex', flexDirection: 'column', height: `100%`, overflowY: 'scroll' }}>
          <Box sx={{ flexGrow: 1, mx: { xs: 3, lg: 6 }, mb: { xs: 3, lg: 6 } }}>
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </Box>
    </BackendReachable>
  </WithAuth>
);
